import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import {
  ConsoleKeyDetailPage,
  consoleConnectorsQueryOptions,
  consoleKeyAuditQueryOptions,
  consoleKeysQueryOptions,
} from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/keys/$keyId")({
  loader: ({ context: { queryClient }, params }) => {
    // No GET /keys/{id} in the contract — the record comes from the list.
    void queryClient.ensureQueryData(consoleKeysQueryOptions());
    void queryClient.ensureQueryData(consoleKeyAuditQueryOptions(params.keyId));
    // Connection labels for the policy view.
    void queryClient.ensureQueryData(consoleConnectorsQueryOptions());
  },
  component: KeyDetailRoute,
});

function KeyDetailRoute(): React.ReactElement {
  const { keyId } = Route.useParams();
  return <ConsoleKeyDetailPage keyId={keyId} />;
}
